(function () {
  'use strict';

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function sentencesFrom(text) {
    var matches = cleanText(text).match(/[^.!?]+(?:[.!?]+(?:[\"'’”)\]]*)|$)/g) || [];
    return matches.map(cleanText).filter(Boolean);
  }

  function buildReadableParagraphs(container) {
    if (!container || container.getAttribute('data-mosaik-formatted') === 'true') return;
    container.setAttribute('data-mosaik-formatted', 'true');

    var structured = container.querySelectorAll('h1,h2,h3,h4,h5,h6,ul,ol,blockquote,table');
    var paragraphs = Array.prototype.filter.call(container.querySelectorAll('p'), function (p) {
      return cleanText(p.textContent).length > 0;
    });

    /* Preserve descriptions that already arrived with genuine editorial structure. */
    if (structured.length || paragraphs.length > 1) return;

    var source = paragraphs.length === 1 ? paragraphs[0] : container;
    var text = cleanText(source.textContent);
    if (text.length < 620) return;

    var sentences = sentencesFrom(text);
    if (sentences.length < 5) return;

    var groups = [];
    var current = [];
    var currentLength = 0;

    sentences.forEach(function (sentence, index) {
      var proposedLength = currentLength + sentence.length + 1;
      var firstGroup = groups.length === 0;
      var maxSentences = firstGroup ? 2 : 3;
      var targetLength = firstGroup ? 360 : 470;

      if (current.length && (current.length >= maxSentences || proposedLength > targetLength)) {
        groups.push(current.join(' '));
        current = [];
        currentLength = 0;
      }

      current.push(sentence);
      currentLength += sentence.length + 1;

      if (index === sentences.length - 1 && current.length) groups.push(current.join(' '));
    });

    if (groups.length < 2) return;

    container.innerHTML = '';
    groups.forEach(function (group, index) {
      var p = document.createElement('p');
      p.textContent = group;
      if (index === 0) p.className = 'mosaik-description-lead';
      container.appendChild(p);
    });
  }

  function init() {
    document.querySelectorAll('.mosaik-product-description__body').forEach(buildReadableParagraphs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
